import { cn } from "@/lib/utils"
import logoHorizontalLight from "@/assets/logo-horizontal-light.svg"
import logoHorizontalDark from "@/assets/logo-horizontal-dark.svg"
import logoVerticalLight from "@/assets/logo-vertical-light.svg"
import logoVerticalDark from "@/assets/logo-vertical-dark.svg"

interface LogoProps {
  className?: string
  showText?: boolean
  variant?: "horizontal" | "vertical"
}

export function Logo({ className, showText = true, variant = "horizontal" }: LogoProps) {
  const lightSrc = variant === "horizontal" ? logoHorizontalLight : logoVerticalLight
  const darkSrc = variant === "horizontal" ? logoHorizontalDark : logoVerticalDark

  const imgClass = variant === "horizontal"
    ? showText ? "h-9 w-auto" : "h-8 w-8 object-contain object-left"
    : "h-24"

  return (
    <div className={cn("flex items-center", className)}>
      <img
        src={lightSrc}
        alt="SOS Enxaqueca"
        className={cn("dark:hidden", imgClass)}
      />
      <img
        src={darkSrc}
        alt="SOS Enxaqueca"
        className={cn("hidden dark:block", imgClass)}
      />
    </div>
  )
}
